var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7056 22.5759C14.9254 23.85 13.0746 23.85 12.2944 22.5759L0.708782 3.65576C-0.107262 2.3231 0.85175 0.611329 2.41441 0.611329L25.5856 0.611331C27.1483 0.611332 28.1073 2.3231 27.2912 3.65576L15.7056 22.5759Z",
    fill: "#9C76AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderArrow);
export default __webpack_public_path__ + "static/media/headerArrow.deb27865d78f2a8ffc0e14122b438a50.svg";
export { ForwardRef as ReactComponent };